import type { ReactNode } from 'react'
import { useHasPermission } from './permissions'

/** Inline conditional render by permission (e.g. hide/disable edit controls for Auditors). */
export function Can({ perm, children, fallback = null }: { perm: string; children: ReactNode; fallback?: ReactNode }) {
  return useHasPermission(perm) ? <>{children}</> : <>{fallback}</>
}
